import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchStores(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('inventory/store', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteStore(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`inventory/store/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
